<template>
  <a-layout id="wrapper">
    <a-layout-header class="header-container">
      <div class="header-content">
        <!-- Logo -->
        <div class="logo-container">
          <img src="/img/logo.png" alt="AutoShopee" class="logo" />
          <span class="logo-text">{{ $t('NAVIGATE_TEXT_PAYMENT') }}</span>
        </div>

        <!-- Desktop Menu -->
        <div class="desktop-menu">
          <a-menu
            theme="light"
            mode="horizontal"
            :default-selected-keys="keyMenu"
            class="main-menu"
          >
            <a-menu-item v-for="item in listMenu" :key="item.key" class="menu-item">
              <a
                :href="item.router"
                :target="item.target"
                class="menu-link"
                :class="{ 'menu-link-highlight': item.highlight }"
                @click="handleMenuClick(item, $event)"
              >
                <span class="menu-icon" style="margin-right: 5px" v-if="item.icon">
                  <i :class="item.icon"></i>
                </span>
                <span class="menu-text">{{ item.text }}</span>
              </a>
            </a-menu-item>
          </a-menu>
        </div>

        <!-- Mobile Menu Toggle -->
        <div class="mobile-menu-toggle">
          <a-button type="text" @click="toggleMobileMenu" class="mobile-toggle-btn">
            <i class="fas fa-bars"></i>
          </a-button>
        </div>
      </div>

      <!-- Mobile Menu -->
      <div v-show="isMobileMenuOpen" class="mobile-menu">
        <a-menu
          theme="light"
          mode="vertical"
          :default-selected-keys="keyMenu"
          class="mobile-menu-list"
        >
          <a-menu-item v-for="item in listMenu" :key="item.key" class="mobile-menu-item">
            <a
              :href="item.router"
              :target="item.target"
              class="mobile-menu-link"
              :class="{ 'menu-link-highlight': item.highlight }"
              @click="handleMenuClick(item, $event)"
            >
              <span class="menu-icon" v-if="item.icon">
                <i :class="item.icon"></i>
              </span>
              <span class="menu-text">{{ item.text }}</span>
            </a>
          </a-menu-item>
        </a-menu>
      </div>
    </a-layout-header>

    <a-layout-content style="padding-top: 60px; min-height: calc(100vh - 60px)">
      <router-view />
    </a-layout-content>

    <div class="contact-float">
      <a
        v-for="contact in contactList"
        :key="contact.key"
        :href="contact.router"
        :target="contact.target"
        :class="['contact-item', contact.class]"
      >
        <span class="icon">
          <i :class="contact.icon" v-if="contact.icon"></i>
          <img
            :src="contact.imgSrc"
            class="contact-icon-img"
            :alt="contact.alt"
            v-if="contact.imgSrc"
          />
        </span>
        <span>{{ contact.label }}</span>
      </a>
    </div>

    <a-layout-footer>
      <div style="text-align: center" class="tex-muted">
        {{ configApp.footer }}
      </div>
    </a-layout-footer>

    <invoice-popup />
  </a-layout>
</template>

<script>
import { mapActions } from 'vuex';
import InvoicePopup from './InvoicePopup.vue';

export default {
  name: 'Layout',
  components: {
    InvoicePopup,
  },
  data() {
    return {
      isMobileMenuOpen: false,
      listMenu: [
        {
          key: 'invoice',
          text: this.$t('CONTACT_INVOICE'),
          router: 'https://zalo.me/2141564390855067259',
          target: '_blank',
          icon: 'fas fa-file-invoice',
          popup: true,
          highlight: true,
        },
        {
          key: 'contact',
          text: this.$t('NAVIGATE_TEXT_CONTACT'),
          router: 'https://support.autoshopee.com/lien-he',
          target: '_blank',
          icon: 'fas fa-headset',
        },
      ],
      keyMenu: ['index'],
      contactList: [
        {
          key: 'facebook',
          label: this.$t('CONTACT_CHAT_FACEBOOK'),
          router: 'https://m.me/toolautoshopee',
          target: '_blank',
          class: 'contact-facebook',
          icon: 'fab fa-facebook-messenger',
        },
        {
          key: 'zalo',
          label: this.$t('CONTACT_CHAT_ZALO'),
          router: 'https://zalo.me/2141564390855067259',
          target: '_blank',
          class: 'contact-zalo',
          imgSrc: '/img/zalo.png',
          alt: 'Zalo',
        },
        {
          key: 'hotline1',
          label: '0904.628.850',
          router: 'tel:0904628850',
          target: '',
          class: 'contact-hotline',
          icon: 'fas fa-phone',
        },
      ],
    };
  },
  computed: {
    clientHeight() {
      return `${document.documentElement.clientHeight + 100}px`;
    },
  },
  methods: {
    ...mapActions('ui', ['openInvoiceModal']),
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    handleMenuClick(item, e) {
      if (item.popup) {
        e.preventDefault();
        this.isMobileMenuOpen = false;
        this.openInvoiceModal();
      }
    },
  },
  mounted() {
    // eslint-disable-next-line arrow-parens
    document.addEventListener('click', e => {
      if (!this.$el.contains(e.target)) {
        this.isMobileMenuOpen = false;
      }
    });
  },
};
</script>

<style scoped>
.header-container {
  position: fixed;
  z-index: var(--z-fixed);
  width: 100%;
  background: var(--bg-primary);
  box-shadow: var(--shadow-sm);
  border-bottom: 1px solid var(--border-color);
  padding: 0;
  top: 0;
  left: 0;
  right: 0;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
  height: 60px;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.logo {
  height: 44px;
  width: auto;
  border-radius: var(--border-radius-md);
}

.logo-text {
  color: var(--text-primary);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  letter-spacing: -0.02em;
}

.desktop-menu {
  display: flex;
  align-items: center;
}

.main-menu {
  background: transparent;
  border: none;
  line-height: 60px;
}

.main-menu .ant-menu-item {
  margin: 0 var(--spacing-xs);
  border-radius: var(--border-radius-md);
  transition: all var(--transition-base);
  height: auto;
  line-height: 1.5;
  color: var(--text-secondary) !important;
}

.main-menu .ant-menu-item:hover {
  background: var(--gray-100);
  color: var(--text-primary) !important;
}

.main-menu .ant-menu-item a {
  color: var(--text-secondary) !important;
}

.main-menu .ant-menu-item:hover a {
  color: var(--primary-color) !important;
}

.menu-link {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  color: var(--text-secondary) !important;
  text-decoration: none;
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--border-radius-md);
  transition: all var(--transition-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-base);
}

.menu-link:hover {
  color: var(--primary-color) !important;
  background: var(--primary-subtle);
}

.menu-link-highlight {
  color: var(--primary-color) !important;
  background: var(--primary-subtle);
  border: 1px solid var(--primary-color);
  font-weight: var(--font-weight-semibold);
}

.menu-link-highlight:hover {
  color: var(--text-inverse) !important;
  background: var(--primary-color);
}

.main-menu .ant-menu-item:hover .menu-link-highlight {
  color: var(--text-inverse) !important;
}

.menu-icon {
  font-size: 18px;
  width: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-text {
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-base);
  color: inherit;
}

.mobile-menu-toggle {
  display: none;
}

.mobile-toggle-btn {
  color: var(--text-primary);
  font-size: 24px;
  border: none;
  background: transparent;
  padding: var(--spacing-sm);
  border-radius: var(--border-radius-md);
  transition: all var(--transition-base);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-toggle-btn:hover {
  background: var(--gray-100);
  color: var(--primary-color);
}

.mobile-menu {
  display: none;
  background: var(--bg-primary);
  border-top: 1px solid var(--border-color);
  box-shadow: var(--shadow-lg);
}

.mobile-menu .ant-menu-item {
  color: var(--text-primary) !important;
}

.mobile-menu .ant-menu-item a {
  color: var(--text-primary) !important;
}

.mobile-menu .ant-menu-item:hover {
  background: var(--primary-light);
}

.mobile-menu .ant-menu-item:hover a {
  color: var(--primary-color) !important;
}

.mobile-menu-list {
  background: transparent;
  border: none;
}

.mobile-menu-item {
  border-bottom: 1px solid var(--border-color);
  margin: 0;
}

.mobile-menu-link {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  color: var(--text-primary) !important;
  text-decoration: none;
  padding: var(--spacing-md) var(--spacing-lg);
  transition: all var(--transition-base);
  font-weight: var(--font-weight-medium);
}

.mobile-menu-link:hover {
  color: var(--primary-color) !important;
  background: var(--primary-subtle);
}

/* Responsive Design */
@media (max-width: 768px) {
  .header-content {
    padding: 0 var(--spacing-sm);
    height: 56px;
  }

  .logo-text {
    display: none;
  }

  .desktop-menu {
    display: none;
  }

  .mobile-menu-toggle {
    display: block;
  }

  .mobile-menu {
    display: block;
  }

  .main-menu {
    display: none;
  }

  .logo {
    height: 36px;
  }
}

@media (max-width: 480px) {
  .header-content {
    padding: 0 var(--spacing-sm);
  }

  .logo {
    height: 32px;
  }
}

/* Animation for mobile menu */
.mobile-menu {
  animation: slideDown var(--transition-slow) ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Custom scrollbar for mobile menu */
.mobile-menu-list {
  max-height: 60vh;
  overflow-y: auto;
}

.mobile-menu-list::-webkit-scrollbar {
  width: 6px;
}

.mobile-menu-list::-webkit-scrollbar-track {
  background: var(--gray-100);
}

.mobile-menu-list::-webkit-scrollbar-thumb {
  background: var(--gray-300);
  border-radius: var(--border-radius-full);
}

.mobile-menu-list::-webkit-scrollbar-thumb:hover {
  background: var(--gray-400);
}

/* Footer styles */
.ant-layout-footer {
  padding: var(--spacing-md) var(--spacing-lg);
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  background: var(--bg-primary);
  text-align: center;
  border-top: 1px solid var(--border-color);
  margin-top: auto;
}

/* Additional menu improvements */
.main-menu .ant-menu-item-selected {
  background: var(--primary-subtle) !important;
  color: var(--primary-color) !important;
}

.main-menu .ant-menu-item-selected .menu-link {
  color: var(--primary-color) !important;
  font-weight: var(--font-weight-semibold);
}

.main-menu .ant-menu-item-selected a {
  color: var(--primary-color) !important;
}

/* Hover effects for better UX */
.menu-link:hover .menu-icon {
  transform: scale(1.1);
  transition: transform var(--transition-fast);
}

.mobile-menu-link:hover .menu-icon {
  transform: scale(1.1);
  transition: transform var(--transition-fast);
}

/* Loading state for mobile menu */
.mobile-menu-toggle .ant-btn-loading {
  color: var(--primary-color);
}

/* Focus states for accessibility */
.menu-link:focus,
.mobile-menu-link:focus,
.mobile-toggle-btn:focus {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

/* Floating Contact Buttons */
.contact-float {
  position: fixed;
  bottom: var(--spacing-xl);
  right: var(--spacing-xl);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  z-index: var(--z-fixed);
}

.contact-item {
  display: flex;
  align-items: center;
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--border-radius-full);
  box-shadow: var(--shadow-md);
  text-decoration: none;
  transition: color var(--transition-base), border-color var(--transition-base), background-color var(--transition-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
  background-color: var(--bg-primary);
  border: 1px solid var(--border-color);
  min-width: 140px;
}

.contact-item:hover {
  color: var(--primary-color);
  border-color: var(--primary-color);
}

.contact-item:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

.contact-item .icon {
  margin-right: var(--spacing-sm);
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: var(--primary-color);
}

.contact-item .contact-icon-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.contact-item.contact-facebook .icon {
  color: #1877f2;
}

.contact-item.contact-hotline {
  background: var(--primary-color);
  color: var(--text-inverse);
  border-color: var(--primary-color);
}

.contact-item.contact-hotline:hover {
  background: var(--primary-hover);
  border-color: var(--primary-hover);
  color: var(--text-inverse);
}

.contact-item.contact-hotline .icon {
  color: var(--text-inverse);
}

@media (max-width: 768px) {
  .contact-float {
    bottom: var(--spacing-md);
    right: var(--spacing-md);
    gap: var(--spacing-xs);
    z-index: var(--z-fixed);
  }

  .contact-item {
    padding: var(--spacing-sm) var(--spacing-md);
    min-width: 120px;
    font-size: var(--font-size-xs);
    box-shadow: var(--shadow-md);
  }

  .contact-item .icon {
    font-size: 16px;
    margin-right: var(--spacing-xs);
    width: 18px;
    height: 18px;
  }

  .contact-item .contact-icon-img {
    width: 16px;
    height: 16px;
  }
}

@media (max-width: 480px) {
  .contact-float {
    bottom: var(--spacing-sm);
    right: var(--spacing-sm);
  }

  .contact-item {
    min-width: 100px;
    padding: var(--spacing-xs) var(--spacing-sm);
    font-size: 11px;
  }
}
</style>
